// extracted by css-extract-rspack-plugin
export default {"modal":"zJo2G7","form":"UKqBtF","body":"lCNLB_","heading":"MaR5Io","fieldRow":"gkowai","fieldRowItem":"IZu_Rh","actions":"qFsRVi"};